import type { FaireProductEntity } from "../../entity_types/product";

export const p_9k5ki1r4bw: FaireProductEntity = {
  token: "p_9k5ki1r4bw",
  type: "product",
  name: "MAGNESIUM SPRAY | 8 oz",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/b2168ce6845efba79e9e4ae31ce3dda30e96a99dce96ee3a27bee78497a074f9.png",
  galleryImageUrls: [],
  priceDollars: 38.5,
  description:
    'Magnesium is essential for over 300 biochemical reactions in our bodies. A magnesium deficiency shows up in the form of migraines, sleepless nights, fatigue, leg cramps, and muscle soreness.\n\nThe most effective way to combat magnesium deficiency without digestive issues is through skin absorption, so our specially formulated spray is the perfect solution!\n\nTO USE: Shake well. Spray 1-2 pumps on stomach, back, legs, or bottoms of feet 1-2x daily. For muscle cramps or pains, spray directly on problem area. May experience tingling sensations, wipe off after 10 minutes if intolerable.\n\nINGREDIENTS: MAGNESIUM OIL, DISTILLED WATER, COLLOIDAL SILVER, 100% PURE THERAPEUTIC GRADE ESSENTIAL OIL: LAVENDER. \n\nDimension: 8 oz, 2.4" x 5.4" x 2.4".',
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:02.500Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
